import styled from "@emotion/styled";
import { Text, Heading } from "@otrium/atoms";
import { Container } from "src/atoms/Container";
import { hideScrollbar } from "src/scrollbar";

export const Term = styled(Heading)`
  line-height: 32px;
  color: ${({ theme }) => theme.colors.tone.black};
  font-size: ${({ theme }) => theme.fontSizes[3]}px;
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    line-height: 40px;
    font-size: ${({ theme }) => theme.fontSizes[4]}px;
  }
`;

export const NoResultsContainer = styled(Container)`
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  ${hideScrollbar}
  padding-block-end: ${({ theme }) => theme.space.space32};

  max-height: calc(
    100dvh -
      (
        (${({ theme }) => theme.space.space64} * 2) +
          ${({ theme }) => theme.space.space48}
      )
  );
`;

export const StyledText = styled(Text)`
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.tone.black};
`;

export const Title = styled(Text)`
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.tone.black};
  &:after {
    content: ":";
  }
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    line-height: 40px;
    font-size: ${({ theme }) => theme.fontSizes[4]}px;
    &:after {
      content: "";
    }
  }
/`;
